<template>
  <div class="kp-modular-section">
    <label class="kp-modular-label">{{$t('edit.sidebar.select_destiny')}}</label>
    <step-jump-select :jump="jump" :selected="selected"></step-jump-select>
  </div>
</template>

<script>
import StepJumpSelect from '../../../../../general/StepJumpSelect.vue';

export default {
  components: {
    StepJumpSelect,
  },
  props: [
    'jump',
    'selected',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** Destiny.vue?24f097f2
 **/